module.exports = __webpack_public_path__ + "static/media/thumb_5.47a01c3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Main/Images/thumb_5.png
// module id = 81
// module chunks = 0